import { gql } from '@apollo/client';
export default gql(`
    mutation DeleteYunoPaymentMethod($input: DeleteYunoPaymentMethodInput! ) {
        deleteYunoPaymentMethod(input: $input)
    }
`);
